'use client';

import { AccountConnectedAccounts as Section } from '../../components/UserProfile/AccountSections';
import { createSection } from '../createSection';

export const UserProfileConnectedAccountsSection = createSection('UserProfileConnectedAccountsSection', Section);
